<div class="angular-editor-toolbar" *ngIf="showToolbar">
  <div aeToolbarSet>
	<button aeButton title="Undo" iconName="undo" (click)="triggerCommand('undo')" [hidden]="isButtonHidden('undo')">
	</button>
	<button aeButton title="Redo" iconName="redo" (click)="triggerCommand('redo')"
			[hidden]="isButtonHidden('redo')">
	</button>
  </div>
  <div aeToolbarSet>
	<button [id]="'bold-'+id" aeButton [title]="'editor.bold' | translate" iconName="bold" (click)="triggerCommand('bold')"
			[disabled]="htmlMode" [hidden]="isButtonHidden('bold')">
	</button>
	<button [id]="'italic-'+id" aeButton iconName="italic" [title]="'editor.italic' | translate" (click)="triggerCommand('italic')"
			[disabled]="htmlMode" [hidden]="isButtonHidden('italic')">
	</button>
	<button [id]="'underline-'+id" aeButton [title]="'editor.underline' | translate" iconName="underline"
			(click)="triggerCommand('underline')" [disabled]="htmlMode" [hidden]="isButtonHidden('underline')">
	</button>
	<button [id]="'strikeThrough-'+id" aeButton iconName="strikeThrough" [title]="'editor.strike' | translate"
			(click)="triggerCommand('strikeThrough')" [disabled]="htmlMode"
			[hidden]="isButtonHidden('strikeThrough')">
	</button>
	<button [id]="'subscript-'+id" aeButton [title]="'editor.sub' | translate" iconName="subscript"
			(click)="triggerCommand('subscript')" [disabled]="htmlMode" [hidden]="isButtonHidden('subscript')">
	</button>
	<button [id]="'superscript-'+id" aeButton iconName="superscript" [title]="'editor.super' | translate"
			(click)="triggerCommand('superscript')" [disabled]="htmlMode"
			[hidden]="isButtonHidden('superscript')">
	</button>
  </div>
  <div aeToolbarSet>
	<button [id]="'justifyLeft-'+id" aeButton iconName="justifyLeft" [title]="'editor.align_left' | translate"
			(click)="triggerCommand('justifyLeft')" [disabled]="htmlMode"
			[hidden]="isButtonHidden('justifyLeft')">
	</button>
	<button [id]="'justifyCenter-'+id" aeButton iconName="justifyCenter"  [title]="'editor.align_center' | translate"
			(click)="triggerCommand('justifyCenter')" [disabled]="htmlMode"
			[hidden]="isButtonHidden('justifyCenter')">
	</button>
	<button [id]="'justifyRight-'+id" aeButton iconName="justifyRight"  [title]="'editor.align_right' | translate"
			(click)="triggerCommand('justifyRight')" [disabled]="htmlMode"
			[hidden]="isButtonHidden('justifyRight')">
	</button>
	<button [id]="'justifyFull-'+id" aeButton iconName="justifyFull" [title]="'editor.justify' | translate"
			(click)="triggerCommand('justifyFull')" [disabled]="htmlMode"
			[hidden]="isButtonHidden('justifyFull')">
	</button>
  </div>
  <div aeToolbarSet>
	<button [id]="'indent-'+id" aeButton iconName="indent" [title]="'editor.indent' | translate"
			(click)="triggerCommand('indent')"
			[disabled]="htmlMode" [hidden]="isButtonHidden('indent')">
	</button>
	<button [id]="'outdent-'+id" aeButton iconName="outdent"  [title]="'editor.outdent' | translate"
			(click)="triggerCommand('outdent')"
			[disabled]="htmlMode" [hidden]="isButtonHidden('outdent')">
	</button>
  </div>
  <div aeToolbarSet>
	<button [id]="'insertUnorderedList-'+id" aeButton iconName="unorderedList" [title]="'editor.ordered_list' | translate"
			(click)="triggerCommand('insertUnorderedList')" [disabled]="htmlMode"
			[hidden]="isButtonHidden('insertUnorderedList')">
	</button>
	<button [id]="'insertOrderedList-'+id" aeButton iconName="orderedList" [title]="'editor.unordered_list' | translate"
			(click)="triggerCommand('insertOrderedList')" [disabled]="htmlMode"
			[hidden]="isButtonHidden('insertOrderedList')">
	</button>
  </div>
  <div aeToolbarSet>
	<ae-select class="select-heading" [options]="headings"
			   [(ngModel)]="block"
			   (change)="triggerCommand(block)"
			   [disabled]="htmlMode"
			   [hidden]="isButtonHidden('heading')"
			   tabindex="-1"></ae-select>
  </div>
  <div aeToolbarSet>
	<ae-select class="select-font" [options]="fonts"
			   [(ngModel)]="fontName"
			   (change)="setFontName(fontName)"
			   [disabled]="htmlMode"
			   [hidden]="isButtonHidden('fontName')"
			   tabindex="-1"></ae-select>
  </div>
  <div aeToolbarSet>
	<ae-select class="select-font-size" [options]="fontSizes"
			   [(ngModel)]="fontSize"
			   (change)="setFontSize(fontSize)"
			   [disabled]="htmlMode"
			   [hidden]="isButtonHidden('fontSize')"
			   tabindex="-1">
	</ae-select>
  </div>
  <div aeToolbarSet>
	<input
	  style="display: none"
	  type="color" (change)="insertColor(fgInput.value, 'textColor')"
	  #fgInput>
	<button [id]="'foregroundColorPicker-'+id" aeButton iconName="textColor"
			(click)="focus(); ; fgInput.click()"
			[title]="'editor.text_color' | translate"
			[disabled]="htmlMode" [hidden]="isButtonHidden('textColor')">
	</button>
	<input
	  style="display: none"
	  type="color" (change)="insertColor(bgInput.value, 'backgroundColor')"
	  #bgInput>
	<button [id]="'backgroundColorPicker-'+id" aeButton iconName="backgroundColor"
			(click)="focus(); ; bgInput.click()"
			[title]="'editor.background_color' | translate"
			[disabled]="htmlMode" [hidden]="isButtonHidden('backgroundColor')">
	</button>
  </div>
  <div *ngIf="_customClasses" aeToolbarSet>
	<ae-select class="select-custom-style" [options]="customClassList"
			   [(ngModel)]="customClassId"
			   (change)="setCustomClass(customClassId)"
			   [disabled]="htmlMode"
			   [hidden]="isButtonHidden('customClasses')"
			   tabindex="-1"></ae-select>
  </div>
  <div aeToolbarSet>
	<button [id]="'link-'+id" aeButton iconName="link" (click)="insertUrl()"
		[title]="'editor.insert_link' | translate" [disabled]="isLinkButtonDisabled" [hidden]="isButtonHidden('link')">
	</button>
	<!-- <button [id]="'unlink-'+id" aeButton iconName="unlink" (click)="removeUrl()"
		[title]="'editor.unlink' | translate" [disabled]="isUnlinkButtonDisabled" [hidden]="isButtonHidden('unlink')">
	</button> -->
	<input
	  style="display: none"
	  accept="image/*"
	  type="file" (change)="onFileChanged($event)"
	  #fileInput>
	<button [id]="'insertImage-'+id" aeButton iconName="image" (click)="focus(); fileInput.click()"
		[title]="'editor.insert_image' | translate"
			[disabled]="htmlMode" [hidden]="isButtonHidden('insertImage')">
	</button>
	<!-- <button [id]="'insertVideo-'+id" aeButton iconName="video"
			(click)="insertVideo()" title="Insert Video" [disabled]="htmlMode"
			[hidden]="isButtonHidden('insertVideo')">
	</button> -->
	<button [id]="'insertHorizontalRule-'+id" aeButton iconName="horizontalLine" [title]="'editor.horizontal_line' | translate"
			(click)="triggerCommand('insertHorizontalRule')" [disabled]="htmlMode"
			[hidden]="isButtonHidden('insertHorizontalRule')">
	</button>
  </div>
  <div aeToolbarSet>
	<button [id]="'clearFormatting-'+id" aeButton iconName="removeFormat" [title]="'editor.clear_formatting' | translate"
			class="angular-editor-button"
			(click)="triggerCommand('removeFormat')" [disabled]="htmlMode" [hidden]="isButtonHidden('removeFormat')">
	</button>
  </div>
  <div aeToolbarSet>
	<button [id]="'toggleEditorMode-'+id" aeButton iconName="htmlCode" [title]="'editor.html_code' | translate"
			(click)="triggerCommand('toggleEditorMode')" [hidden]="isButtonHidden('toggleEditorMode')">
	</button>
  </div>
  <ng-content></ng-content>
</div>

<div
	#linkToolip
	class="link-tooltip flex-column hidden"
>
		<div
			class="cursor-pointer"
			[title]="'editor.edit_link' | translate"
					(click)="editURL()"
					(blur)="hideLinkTooltip()"
			>
			{{'editor.edit_link' | translate}}
		</div>

		<div
			class="cursor-pointer"
			[title]="'editor.edit_link' | translate"
					(click)="removeURL()"
					(blur)="hideLinkTooltip()"
			>
			{{'editor.unlink' | translate}}
		</div>

</div>
